(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["collection-sidebar-search"] && !Shopify.designMode) return;
  try {
    jQuery(function($) {
    $('.canvas-icon, .close-mobile-canvas').on('click', function() {
      $('body').toggleClass('mobile-canvas-shown');
      if ($('body').hasClass('mobile-canvas-shown')) {
        setTimeout(function() {
          $(document).one('click', function(e) {
            var $target = $(e.target);
            if (!$target.closest('.block-main-canvas').length) {
              $('body').removeClass('mobile-canvas-shown');
            }
          });
        }, 110);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
